'use strict';

exports.__esModule = true;
exports.TaskView = exports.styles = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Task = require('../../../../../Tasks/View/Task');

var _materialUi = require('material-ui');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

exports.styles = _Task.styles;

var TaskView = exports.TaskView = function (_BaseTaskView) {
  _inherits(TaskView, _BaseTaskView);

  function TaskView() {
    _classCallCheck(this, TaskView);

    return _possibleConstructorReturn(this, _BaseTaskView.apply(this, arguments));
  }

  TaskView.prototype.renderDefaultView = function renderDefaultView() {
    return null;
  };

  TaskView.prototype.renderEditableView = function renderEditableView() {
    return this.renderDefaultView();
  };

  return TaskView;
}(_Task.TaskView); // export default processors(withStyles(styles)(props => <TaskView
//   {...props}
// />));


exports.default = (0, _materialUi.withStyles)(_Task.styles)(function (props) {
  return _react2.default.createElement(_Task.TaskConnector, _extends({}, props, {
    View: TaskView
  }));
});